module.exports = __webpack_public_path__ + "static/img/sec 07.3061fef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-mini/sec 07.png
// module id = 6dvb
// module chunks = 12